import React from 'react';
import PropTypes from 'prop-types';

export default function Noscript({ innerHtml }) {
  if (!innerHtml) {
    return null;
  }
  return <noscript dangerouslySetInnerHTML={{ __html: innerHtml }} />;
}

Noscript.defaultProps = {
  innerHtml: ''
};

Noscript.propTypes = {
  innerHtml: PropTypes.string
};
